export default __webpack_public_path__ + "static/media/donate-07.cdfca1dc.png";